import moment from 'moment'

function convertTime (date, format = 'YYYY/MM/DD', location = 'Asia/Tokyo') {
  return moment.tz(new Date(date), location).format(format)
}

export { convertTime }
